import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import ListTransfer from 'components/transfer/ListTransfer'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { gettingExtraReport, updatingExtraReport } from 'utils/ExtraReport';


const AssignReport = ({ open, setOpen, row }) => {
    const { t } = useTranslation();

    const [loadingData, setLoadingData] = useState(false);
    const [, setLoadingUpdate] = useState(false);
    const [reports, setReports] = useState([]);
    const [selected, setSelected] = useState([]);
    const [cache, setCache] = useState([]);
    const [categories, setCategories] = useState([]);

    const closing = () => {
        setOpen(false);
        setLoadingData(false);
        setLoadingUpdate(false);
        setReports([]);
        setSelected([]);
        setCategories([]);
        setCache([]);
    }

    useEffect(() => {
        if (open) {
            gettingExtraReport(setLoadingData, row.id, row.profile_id, setSelected, setCache, setReports, setCategories)
        }
    }, [open])

    return (
        <>
            <Dialog
                open={open}
                onClose={() => closing}
            >
                <DialogTitle>
                    <Typography variant='body3'>{'Asignar reportes'}</Typography>
                </DialogTitle>

                <DialogContent dividers>
                    <ListTransfer
                        loading={loadingData}
                        allItems={reports}
                        right={selected}
                        setRight={setSelected}
                        textLeft={'Reportes'}
                        textRight={'Reportes asignadas'}
                        textSelected={'Seleccionadas'}
                    />
                </DialogContent>

                <DialogActions sx={{ pr: 3 }}>
                    <LoadingButton
                        variant='contained'
                        disableElevation
                        onClick={() => {
                            //updatingProfileCategory(setLoadingUpdate, profileId, selected, closing)
                            const difference = [
                                ...selected.filter((x) => !cache.includes(x)).map(id => ({ id, add: true })), // se agregan
                                ...cache.filter((x) => !selected.includes(x)).map(id => ({ id, add: false })) // se eliminan
                            ]

                            console.log(difference)

                            updatingExtraReport(setLoadingUpdate, categories, difference, row.id, closing)
                        }}
                    //loading={loadingUpdate}
                    //disabled={loadingUpdate}
                    >
                        {t('settings.paycodes.table.modals.add.buttons.save')}
                    </LoadingButton>

                    <Button variant='contained' disableElevation color='error' onClick={() => closing()}>
                        {t('settings.paycodes.table.modals.add.buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export { AssignReport }